import TrendingSummaryCard from './trendingSummaryCard.container';

export default TrendingSummaryCard;